module.exports = __webpack_public_path__ + "static/media/sr-CS.3acd70d4.md";